<div class="modal fade logistics-bulk-modal logistics-attributes-modal" id="customColumnEditModal" tabindex="-1" role="dialog" aria-labelledby="customColumnEditModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="customColumnEditModalLabel">Edit company attributes</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p class="logistics-modal-intro" *ngIf="selection">Update a field for {{ selectionCount(selection) | number }} selected {{ selectionCount(selection) === 1 ? 'company' : 'companies' }}.</p>
                <label class="logistics-modal-label" for="bulkAttributeSelection">Choose attribute</label>
                <select id="bulkAttributeSelection" [(ngModel)]="columnToAssignSelected" class="custom-select" name="columnToAssignSelected">
                    <option [ngValue]="null" disabled>Choose an attribute</option>
                    <ng-container *ngFor="let customColumn of inputParams.customColumns">
                         <option *ngIf="customColumn.can_edit || isSuperUser" [ngValue]="customColumn">{{customColumn.name}}</option>
                    </ng-container>
                </select>
                <label class="logistics-modal-label logistics-modal-spaced-label" *ngIf="columnToAssignSelected">Set value</label>
                <custom-column-edit
                        [selection]="selection"
                        *ngIf="columnToAssignSelected"
                        [inputParams]="{
                            'customColumn': columnToAssignSelected,
                            'companyIds': companyIds,
                            'displayTight': false,
                            'submitThroughButton': true,
                            'isSuperUser': isSuperUser,
                            'teamMembers': inputParams.teamMembers
                         }" (onCustomColumnSaved)="showBulkAssignedMessageAndUpdateResults($event[0])"></custom-column-edit>
                <p class="logistics-modal-success" *ngIf="bulkAssignedMessageVisible">These attributes were successfully updated.</p>
            </div>
        </div>
    </div>
</div>
